import styled from 'styled-components';
export const IconWrapper = styled.div `
  margin-bottom: 1.4rem;

  ${({ theme }) => theme.media.tablet `
    margin-bottom: 2.1rem;
  `};
`;
export const MainBlock = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;

  margin-bottom: 1.1rem;
  padding: 1.4rem 0;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.default};

  ${IconWrapper} {
    margin-right: 1.4rem;
    margin-bottom: 0;

    ${({ theme }) => theme.media.tablet `
        margin-bottom: 2.1rem;
        margin-right: 0;
    `};
  }

  ${({ theme }) => theme.media.tablet `
    flex-direction: column;
    align-items: start;
    justify-content: initial;

    width: 33%;

    padding: 1.7rem 1.7rem 1.3rem;
    margin-bottom: 0;
    margin-right: 2.3rem;

    border-color: ${theme.colors.surface.disabled};

    background-color: ${theme.colors.surface.interactiveDefault};
  `};
`;
export const TextWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const SecondaryContent = styled.div `
  display: flex;

  width: 100%;

  ${({ theme }) => theme.media.tablet `
    width: 66.6%;
  `};
`;
export const Block = styled.div `
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: initial;

  width: 100%;

  padding: 1.7rem 1.7rem 1.3rem;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.default};

  &:first-child {
    margin-right: 0.9rem;
  }

  ${({ theme }) => theme.media.tablet `


    border-color: ${theme.colors.surface.disabled};

    background-color: ${theme.colors.surface.interactiveDefault};

    &:first-child {
      margin-right: 2.3rem;
    }
  `};
`;
export const PercentageIcon = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  width: 3.4rem;
  height: 3.4rem;

  background-color: ${({ theme }) => theme.colors.interactive.brandColorDisabled};

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  ${({ theme }) => theme.media.tablet `
    width: 3.8rem;
    height: 3.8rem;
  `};
`;
//# sourceMappingURL=styles.js.map